// Function to send a chat message to the backend
export const sendChatMessage = async (message) => {
  try {
    const response = await fetch(`/api/ask`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending chat message:", error);
    throw error;
  }
};

// Function to check API health
export const checkApiHealth = async () => {
  try {
    const response = await fetch(`/api/health`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error checking API health:", error);
    throw error;
  }
};

// Function to query PDF content using RAG
export const queryPDFContent = async (pdfContent, question) => {
  try {
    const response = await fetch(`/api/ask`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pdfContent, question }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error querying PDF content:", error);
    throw error;
  }
};
